<template>
    <div class="reset-password-container">
        <checkPhone
            v-if="resetStatus === 'check-phone'"
            @phoneInfo="phoneInfo"
        />
        <companyList
            v-if="resetStatus === 'company-list'"
            :companies="companies"
            @phoneInfo="phoneInfoSingle"
        />
        <resetPassword
            v-if="resetStatus === 'reset-password'"
            :info="info"
            :show-last-step="showLastStep"
            @reback="reback"
        />
    </div>
</template>
<script>
import checkPhone from './components/checkPhone.vue';
import companyList from './components/companyList.vue';
import resetPassword from './components/resetPassword.vue';

export default {
    components: {
        checkPhone,
        companyList,
        resetPassword,
    },
    data() {
        return {
            resetStatus: 'check-phone',
            companies: [],
            info: {},
            showLastStep: false,
        };
    },
    methods: {
        phoneInfo(params) {
            this.companies = params;
            if (params.aidList.length > 1) {
                this.resetStatus = 'company-list';
                this.showLastStep = true;
            } else {
                const detail = params.aidList[0];
                this.info = {
                    phoneNumber: params.phoneNumber,
                    verifyCode: params.verifyCode,
                    ...detail,
                };
                this.resetStatus = 'reset-password';
            }
        },
        phoneInfoSingle(param) {
            this.info = {
                phoneNumber: param.phoneNumber,
                verifyCode: param.verifyCode,
                aid: param.aid,
                name: param.name,
                account: param.account, // 账户名字段
                company: param.corp_short_name, // 公司名
            };
            this.resetStatus = 'reset-password';
        },
        reback() {
            this.resetStatus = 'company-list';
        },
    },
};
</script>
<style lang="less">
body {
    background: #f8fafb;
}
.reset-password-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafb;
}
</style>
